/* eslint-disable max-lines-per-function */
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';

export function Mitarbeiter({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const percentage =
    (rotationsplan.getAbgeschlosseneStationen().length * 100) /
    rotationsplan.getAmountOfStationen();

  return (
    <div className="flex items-center justify-between">
      <div className="flex gap-2 items-center">
        <Avatar>
          <AvatarImage
            alt={rotationsplan.mitarbeiter.getName()}
            src={rotationsplan.mitarbeiter.imgUrl}
          />
          <AvatarFallback>
            {rotationsplan.mitarbeiter.getInitials()}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col min-w-0">
          <div className="text-sm text-neutrals-900 truncate">
            {rotationsplan.mitarbeiter.vorname +
              ' ' +
              rotationsplan.mitarbeiter.nachname}
          </div>
          <div className="text-xs text-neutrals-700">
            {rotationsplan.getCurrentLehrjahr() +
              ' ⋅ ' +
              rotationsplan.beruf.abkuerzung}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="relative w-6 h-6 rounded-full">
          <svg className="w-full h-full" viewBox="0 0 100 100">
            <circle
              className="text-neutrals-300 stroke-current"
              strokeWidth="10"
              cx="50"
              cy="50"
              r="45"
              fill="transparent"
            />
            {percentage > 0 && (
              <circle
                className={
                  'text-primary-blue-600 progress-ring__circle stroke-current'
                }
                strokeWidth="10"
                strokeLinecap="round"
                cx="50"
                cy="50"
                r="45"
                fill="transparent"
                strokeDashoffset={280 - (280 * percentage) / 100}
              />
            )}
          </svg>
        </div>
        <div className="flex items-baseline gap-1">
          <div className="text-neutrals-900 font-semibold text-sm">
            {rotationsplan.getAbgeschlosseneStationen().length}
          </div>
          <div className="text-neutrals-700 text-xs">/</div>
          <div className="text-neutrals-700 text-xs">
            {rotationsplan.getAmountOfStationen()}
          </div>
        </div>
      </div>
    </div>
  );
}
